var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"magic-banner-wrap"},[_c('div',{class:'magic-banner ' + _vm.placement},[_c('div',{staticClass:"magic-text"},[_c('div',{staticClass:"title1"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"title2"},[_vm._v(" "+_vm._s(_vm.desc)+" ")])]),_c('div',{staticClass:"magic-img"},[_c('img',{attrs:{"src":_vm.img}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }